var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
        this.storage = new Map();
    }
    LocalStorage.prototype.get = function (state) {
        if (!state) {
            return;
        }
        var key = "kc-callback-" + state;
        var value;
        if (this.storage.has(key)) {
            value = this.storage.get(key);
        }
        this.clearExpired();
        return value;
    };
    LocalStorage.prototype.add = function (state) {
        this.clearExpired();
        var key = "kc-callback-" + state.state;
        this.storage.set(key, __assign(__assign({}, state), { expires: new Date().getTime() + 60 * 60 * 1000 }));
    };
    LocalStorage.prototype.clearExpired = function () {
        var _this = this;
        var time = new Date().getTime();
        Array.from(this.storage.entries())
            .filter(function (_a) {
            var key = _a[0], state = _a[1];
            return key.startsWith("kc-callback-") &&
                (!state.expires || state.expires < time);
        })
            .map(function (_a) {
            var key = _a[0];
            return key;
        })
            .forEach(function (keyToRemove) {
            _this.storage.delete(keyToRemove);
        });
    };
    return LocalStorage;
}());
export default LocalStorage;
//# sourceMappingURL=storage.js.map